import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
// import { ErrorMessage, Field, Form, Formik, useFormik } from "formik";
import React from "react";
import PropTypes from "prop-types";

export class ConfirmModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };

    this.confirmMessage = this.props.confirmMessage;
    this.titleMessage = this.props.titleMessage;
  }

  showModal() {
    this.setState({ show: true });
  }

  hideModal() {
    this.setState({ show: false });
  }

  render() {
    return (
      <CModal show={this.state.show} onClose={() => this.hideModal()}>
        <CModalHeader closeButton>
          <CModalTitle>{this.titleMessage}</CModalTitle>
        </CModalHeader>
        <CModalBody>{this.confirmMessage}</CModalBody>
        <CModalFooter>
          <CButton
            color="success"
            data-attr="models:btn:confirm-action"
            onClick={() => {
              this.props.confirmAction();
              this.hideModal();
            }}
          >
            Confirm
          </CButton>
          <CButton
            color="secondary"
            data-attr="models:btn:cancel-action"
            onClick={() => this.hideModal()}
          >
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

ConfirmModal.propTypes = {
  confirmAction: PropTypes.func.isRequired,
  confirmMessage: PropTypes.string.isRequired,
  titleMessage: PropTypes.string.isRequired,
};
